import './edit-transport-type.scss';

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Outlet } from 'react-router-dom';

import FormTransportType from "../form-transport-type/form-transport-type";
import { useEditTransportType } from "./edit-transport-type.hook";

export function EditTransportType() {
  const {
    transportTypeData,
    isLoading,
    transportTypeError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditTransportType();

  const title =
    transportTypeData?.name ? <h1>{ transportTypeData?.name }</h1> : <h1>Edit Transport Type</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormTransportType />
        <Outlet />
      </section>
    </div>
  );

  return (
    <div id="EditTransportType" className="transport-type">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>
      
      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          { transportTypeError && !isLoading && displayError }
          {!isLoading ? mainContent : null}
         </FormProvider>
      </section>
    </div>
  );
}

export default EditTransportType;